import {call, ForkEffect, put, select, takeLatest} from 'redux-saga/effects';
import axios from 'axios';
import {
    FIND_ROOM_BY_ID,
    IFindRoomByIdAction,
    IUpdateCurrentOwnerSlideAction,
    UPDATE_CURRENT_OWNER_SLIDE,
} from '../actions/types/roomRunFile.actions.types';
import {updateRoomReducerAction, updateRoomRunFileAction} from '../actions/roomRunFile.actions';
import {createRoomRunFile, fetchRoom, fetchRoomRunFileByRoomId, saveRoomRunFile} from '../../service/room.service';
import {IRoomRunFile} from '../../incase-domain/proptypes/IRoomRunFile';
import {AppState} from '../reducer';
import {IFetchRoom} from '../../incase-domain/rooms/room.player';
import {updateCurrentSlide} from '../actions/presentation.actions';
import {getPresentationInRoomAction} from '../actions/dashboard.actions';
import {setPasswordErrorAction, setRoomInfoModalAction} from '../actions/roomProtection.actions';

export function* findRoomByIdSaga(action: IFindRoomByIdAction): unknown {
    const {roomId, params, credential, hash, presenterCode} = action.payload;
    let room: IFetchRoom;

    try {
        room = yield call(fetchRoom, roomId, credential?.password || '', hash, presenterCode);
    } catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 403) {
            yield put(setPasswordErrorAction(error.response?.data.message || 'validations.credentials.incorrectPasswor'));
            return;
        }
        yield put(setRoomInfoModalAction(true, 'lobby.modals.roomNotFound', 'lobby.modals.roomNotFoundDesc'));
        return;
    }

    if (room.isPresenter && !room.isOwner && !room.isAllowed) {
        yield put(setRoomInfoModalAction(true, 'lobby.modals.roomPrivate', 'lobby.modals.roomPrivateDesc'));
        return;
    }
    if (!room.isAllowed) {
        yield put(setRoomInfoModalAction(true, 'message.warning.notAllowedInRoom', 'lobby.modals.notAllowed'));
        return;
    }

    if (!room.isPresenter && !room.roomRunFileId) {
        yield put(setRoomInfoModalAction(true, 'lobby.modals.roomNotActive', 'lobby.modals.roomNotActiveDesc'));
        return;
    }

    let roomRunFile: IRoomRunFile = yield call(fetchRoomRunFileByRoomId, roomId);

    if (room.isPresenter && !room.roomRunFileId) {
        roomRunFile = yield call(createRoomRunFile, roomId, params, presenterCode, hash);
    }

    yield put(updateRoomReducerAction({...room, roomRunFileId: roomRunFile._id}));
    yield put(updateRoomRunFileAction(roomRunFile));

    yield put(getPresentationInRoomAction(params, credential, hash, presenterCode));

    yield put(updateCurrentSlide(roomRunFile.ownerCurrentSlideIndex));
}

export function* updateCurrentOwnerSlideSaga(slideIndex: IUpdateCurrentOwnerSlideAction): unknown {
    const state: AppState = yield select();
    const {roomRunFile} = state.roomRunFileReducer;

    roomRunFile.ownerCurrentSlideIndex = slideIndex.slideIndex;

    const updatedRoomRunFile = {
        ...roomRunFile,
        currentSlideIndex: roomRunFile.ownerCurrentSlideIndex,
    };
    yield put(updateRoomRunFileAction(updatedRoomRunFile));
    yield call(saveRoomRunFile, updatedRoomRunFile);
}

export function* watchRoomRunFileSaga(): Generator<ForkEffect<never>, void> {
    yield takeLatest(FIND_ROOM_BY_ID, findRoomByIdSaga);
    yield takeLatest(UPDATE_CURRENT_OWNER_SLIDE, updateCurrentOwnerSlideSaga);
}
